import { render, staticRenderFns } from "./ImpactStatCard.vue?vue&type=template&id=a5e64c7c&scoped=true"
import script from "./ImpactStatCard.vue?vue&type=script&lang=js"
export * from "./ImpactStatCard.vue?vue&type=script&lang=js"
import style0 from "./ImpactStatCard.vue?vue&type=style&index=0&id=a5e64c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e64c7c",
  null
  
)

export default component.exports